var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashSolidBBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.225 0.983984L4 1.375H1C0.446875 1.375 0 1.76602 0 2.25C0 2.73398 0.446875 3.125 1 3.125H13C13.5531 3.125 14 2.73398 14 2.25C14 1.76602 13.5531 1.375 13 1.375H10L9.775 0.983984C9.60625 0.685938 9.25938 0.5 8.88125 0.5H5.11875C4.74062 0.5 4.39375 0.685938 4.225 0.983984ZM13 4H1L1.6625 13.2695C1.7125 13.9613 2.36875 14.5 3.15937 14.5H10.8406C11.6312 14.5 12.2875 13.9613 12.3375 13.2695L13 4Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSolidBBlack);
export default __webpack_public_path__ + "static/media/trash-solid-b-black.8b9355b62c01bb1ac72949a8030b1790.svg";
export { ForwardRef as ReactComponent };